// extracted by mini-css-extract-plugin
module.exports = {"DeleteIcon":"DeleteIcon_7bBoF"};